// Code generated by Tortuga protoc-gen-rest-ts. DO NOT EDIT.

/* eslint-disable */
import { ApiError } from "src/core/apiError";
import {
  ReST,
  generateQueryParams,
  generatePayload
} from "src/utils/api/rest/rest";
import { GetLinkedAccountsResponse } from "src/gen/schema/bilge/api";
import { GetCandidateInfoWithPasscodeRequest } from "src/gen/schema/bilge/api";
import { GetCandidateInfoWithPasscodeResponse } from "src/gen/schema/bilge/api";
import { GetInvitationsResponse } from "src/gen/schema/bilge/api";
import { GetAllFansResponse } from "src/gen/schema/bilge/api";
import { AssertRestCounterReportRequest } from "src/gen/schema/reader/reader_api";
import { UpdateChatbotFeatureFlagsRequest } from "src/gen/schema/bilge/api";
import { EchoResponse } from "src/gen/schema/common/echo";
import { ChatbotFeatureFlagsResponse } from "src/gen/schema/bilge/api";
import { CliCommandResponse } from "src/gen/schema/bilge/api";
import { GetImageTargetsRequest } from "src/gen/schema/bilge/api";
import { DiscoverTopologyRequest } from "src/gen/schema/bilge/api";
import { DiscoverTopologyResponse } from "src/gen/schema/bilge/api";
import { CablingRequest } from "src/gen/schema/bilge/api";
import { GetSwitchGroupImageTargetsRequest } from "src/gen/schema/bilge/api";
import { GetInventoryCountsResponse } from "src/gen/schema/bilge/api";
import { AssertionHistoryQueryRequest } from "src/gen/schema/reader/reader_api";
import { AssertCounterReportResponse } from "src/gen/schema/reader/reader_api";
import { UpdateLinkedAccountRequest } from "src/gen/schema/bilge/api";
import { UpdateLinkedAccountResponse } from "src/gen/schema/bilge/api";
import { StopCliCommandRequest } from "src/gen/schema/bilge/api";
import { GetDevicesForOrgResponse } from "src/gen/schema/bilge/api";
import { GetAllPluggablesResponse } from "src/gen/schema/bilge/api";
import { AssertionHistoryQueryResponse } from "src/gen/schema/reader/reader_api";
import { GetDiscoveredDevicesResponse } from "src/gen/schema/bilge/api";
import { GetFabricConfigDiffResponse } from "src/gen/schema/bilge/api";
import { SetLinkedAccountResponse } from "src/gen/schema/bilge/api";
import { CablingResponse } from "src/gen/schema/bilge/api";
import { HistoryResponse } from "src/gen/schema/reader/reader_api";
import { GetDciConfigDiffResponse } from "src/gen/schema/bilge/api";
import { JsonRpcRequest } from "src/gen/schema/bilge/api";
import { GetAllPsusResponse } from "src/gen/schema/bilge/api";
import { EchoRequest } from "src/gen/schema/common/echo";
import { CliCommandRequest } from "src/gen/schema/bilge/api";
import { GetSwitchGroupImageTargetsResponse } from "src/gen/schema/bilge/api";
import { HistoryRequest } from "src/gen/schema/reader/reader_api";
import { AssertRestRecordRequest } from "src/gen/schema/reader/reader_api";
import { GetFabricConfigRevisionDiffRequest } from "src/gen/schema/bilge/api";
import { GetImageTargetsResponse } from "src/gen/schema/bilge/api";
import { GetFabricConfigDiffRequest } from "src/gen/schema/bilge/api";
import { GetDciConfigDiffRequest } from "src/gen/schema/bilge/api";
import { GetFabricConfigRevisionDiffResponse } from "src/gen/schema/bilge/api";
import { JsonRpcResponse } from "src/gen/schema/bilge/api";
import { SetLinkedAccountRequest } from "src/gen/schema/bilge/api";
import { DeleteLinkedAccountRequest } from "src/gen/schema/bilge/api";
import { GetLinkedAccountsRequest } from "src/gen/schema/bilge/api";
import { AssertHistoryApiRecordResponse } from "src/gen/schema/reader/reader_api";

export const Bilge = {
  echo: (
    request: EchoRequest,
    options?: RequestInit | undefined
  ): Promise<EchoResponse> => {
    return ReST.post(
      `/api/v1/hidden/echo/bilge`,
      generatePayload(request, EchoRequest),
      options
    ).then((response) => response.json())
      .then(EchoResponse.fromJSON);
  },
  setLinkedAccount: (
    request: SetLinkedAccountRequest,
    options?: RequestInit | undefined
  ): Promise<SetLinkedAccountResponse> => {
    return ReST.post(
      `/api/v1/chatbots/linkedAccounts`,
      generatePayload(request, SetLinkedAccountRequest),
      options
    ).then((response) => response.json())
      .then(SetLinkedAccountResponse.fromJSON);
  },
  updateLinkedAccount: (
    request: UpdateLinkedAccountRequest,
    options?: RequestInit | undefined
  ): Promise<UpdateLinkedAccountResponse> => {
    //Validate Path Param: accountId
    if (!request.accountId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.accountId is invalid.")
      );
    }
    return ReST.put(
      `/api/v1/chatbots/linkedAccounts/${request.accountId}`,
      generatePayload(request, UpdateLinkedAccountRequest),
      options
    ).then((response) => response.json())
      .then(UpdateLinkedAccountResponse.fromJSON);
  },
  deleteLinkedAccount: (
    request: DeleteLinkedAccountRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Validate Path Param: accountId
    if (!request.accountId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.accountId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["accountId"]
    );
    return ReST.delete(
      `/api/v1/chatbots/linkedAccounts/${request.accountId}${queryParams}`,
      options
    );
  },
  getLinkedAccounts: (
    request: GetLinkedAccountsRequest,
    options?: RequestInit | undefined
  ): Promise<GetLinkedAccountsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/chatbots/linkedAccounts${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetLinkedAccountsResponse.fromJSON);
  },
  getChatbotFeatureFlags: (
    options?: RequestInit | undefined
  ): Promise<ChatbotFeatureFlagsResponse> => {
    return ReST.get(
      `/api/v1/chatbots/featureFlags`,
      options
    ).then((response) => response.json())
      .then(ChatbotFeatureFlagsResponse.fromJSON);
  },
  updateChatbotFeatureFlags: (
    request: UpdateChatbotFeatureFlagsRequest,
    options?: RequestInit | undefined
  ): Promise<ChatbotFeatureFlagsResponse> => {
    return ReST.put(
      `/api/v1/chatbots/featureFlags`,
      generatePayload(request, UpdateChatbotFeatureFlagsRequest),
      options
    ).then((response) => response.json())
      .then(ChatbotFeatureFlagsResponse.fromJSON);
  },
  getChatAccountCandidateWithPasscode: (
    request: GetCandidateInfoWithPasscodeRequest,
    options?: RequestInit | undefined
  ): Promise<GetCandidateInfoWithPasscodeResponse> => {
    return ReST.post(
      `/api/v1/chatbots/linkedAccounts/candidates`,
      generatePayload(request, GetCandidateInfoWithPasscodeRequest),
      options
    ).then((response) => response.json())
      .then(GetCandidateInfoWithPasscodeResponse.fromJSON);
  },
  getChatbotInvitations: (
    options?: RequestInit | undefined
  ): Promise<GetInvitationsResponse> => {
    return ReST.get(
      `/api/v1/chatbots/invitations`,
      options
    ).then((response) => response.json())
      .then(GetInvitationsResponse.fromJSON);
  },
  tCliCommand: (
    request: CliCommandRequest,
    options?: RequestInit | undefined
  ): Promise<CliCommandResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/ui/v1/cli${queryParams}`,
      options
    ).then((response) => response.json())
      .then(CliCommandResponse.fromJSON);
  },
  stopTCliCommand: (
    request: StopCliCommandRequest,
    options?: RequestInit | undefined
  ): Promise<Response> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.delete(
      `/ui/v1/cli${queryParams}`,
      options
    );
  },
  cabling: (
    request: CablingRequest,
    options?: RequestInit | undefined
  ): Promise<CablingResponse> => {
    return ReST.post(
      `/ui/v1/cabling`,
      generatePayload(request, CablingRequest),
      options
    ).then((response) => response.json())
      .then(CablingResponse.fromJSON);
  },
  getImageTargets: (
    request: GetImageTargetsRequest,
    options?: RequestInit | undefined
  ): Promise<GetImageTargetsResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/image/targets${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetImageTargetsResponse.fromJSON);
  },
  getSwitchGroupImageTargets: (
    request: GetSwitchGroupImageTargetsRequest,
    options?: RequestInit | undefined
  ): Promise<GetSwitchGroupImageTargetsResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/switchGroupImageTargets${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetSwitchGroupImageTargetsResponse.fromJSON);
  },
  getDevicesForOrg: (
    options?: RequestInit | undefined
  ): Promise<GetDevicesForOrgResponse> => {
    return ReST.get(
      `/api/v1/devices`,
      options
    ).then((response) => response.json())
      .then(GetDevicesForOrgResponse.fromJSON);
  },
  getAllFans: (
    options?: RequestInit | undefined
  ): Promise<GetAllFansResponse> => {
    return ReST.get(
      `/api/v1/inventory/fans`,
      options
    ).then((response) => response.json())
      .then(GetAllFansResponse.fromJSON);
  },
  getAllPsus: (
    options?: RequestInit | undefined
  ): Promise<GetAllPsusResponse> => {
    return ReST.get(
      `/api/v1/inventory/psus`,
      options
    ).then((response) => response.json())
      .then(GetAllPsusResponse.fromJSON);
  },
  getAllPluggables: (
    options?: RequestInit | undefined
  ): Promise<GetAllPluggablesResponse> => {
    return ReST.get(
      `/api/v1/inventory/pluggables`,
      options
    ).then((response) => response.json())
      .then(GetAllPluggablesResponse.fromJSON);
  },
  getInventoryCounts: (
    options?: RequestInit | undefined
  ): Promise<GetInventoryCountsResponse> => {
    return ReST.get(
      `/api/v1/inventory/counts`,
      options
    ).then((response) => response.json())
      .then(GetInventoryCountsResponse.fromJSON);
  },
  queryAssertionHistoryMessage: (
    request: HistoryRequest,
    options?: RequestInit | undefined
  ): Promise<HistoryResponse> => {
    return ReST.post(
      `/ui/v1/assertions`,
      generatePayload(request, HistoryRequest),
      options
    ).then((response) => response.json())
      .then(HistoryResponse.fromJSON);
  },
  queryAssertionHistory: (
    request: AssertionHistoryQueryRequest,
    options?: RequestInit | undefined
  ): Promise<AssertionHistoryQueryResponse> => {
    return ReST.post(
      `/ui/v1/assertions/query`,
      generatePayload(request, AssertionHistoryQueryRequest),
      options
    ).then((response) => response.json())
      .then(AssertionHistoryQueryResponse.fromJSON);
  },
  getAssertionHistoryCounterReport: (
    request: AssertRestCounterReportRequest,
    options?: RequestInit | undefined
  ): Promise<AssertCounterReportResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/assertions/counters${queryParams}`,
      options
    ).then((response) => response.json())
      .then(AssertCounterReportResponse.fromJSON);
  },
  getAssertionHistoryRecord: (
    request: AssertRestRecordRequest,
    options?: RequestInit | undefined
  ): Promise<AssertHistoryApiRecordResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/api/v1/assertions/records${queryParams}`,
      options
    ).then((response) => response.json())
      .then(AssertHistoryApiRecordResponse.fromJSON);
  },
  getDiscoveredDevices: (
    options?: RequestInit | undefined
  ): Promise<GetDiscoveredDevicesResponse> => {
    return ReST.get(
      `/api/v1/devices/neighbors`,
      options
    ).then((response) => response.json())
      .then(GetDiscoveredDevicesResponse.fromJSON);
  },
  getFabricConfigDiff: (
    request: GetFabricConfigDiffRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricConfigDiffResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/diffs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricConfigDiffResponse.fromJSON);
  },
  getDciConfigDiff: (
    request: GetDciConfigDiffRequest,
    options?: RequestInit | undefined
  ): Promise<GetDciConfigDiffResponse> => {
    //Validate Path Param: dciId
    if (!request.dciId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.dciId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["dciId"]
    );
    return ReST.get(
      `/api/v1/dcis/${request.dciId}/diffs${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetDciConfigDiffResponse.fromJSON);
  },
  getFabricConfigRevisionDiff: (
    request: GetFabricConfigRevisionDiffRequest,
    options?: RequestInit | undefined
  ): Promise<GetFabricConfigRevisionDiffResponse> => {
    //Validate Path Param: fabricId
    if (!request.fabricId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.fabricId is invalid.")
      );
    }
    //Validate Path Param: revisionId
    if (!request.revisionId) {
      return Promise.reject(
        ApiError.fromMessage("Request Validation Failed: request.revisionId is invalid.")
      );
    }
    //Generate query params
    const queryParams = generateQueryParams(
      request, ["fabricId", "revisionId"]
    );
    return ReST.get(
      `/api/v1/fabrics/${request.fabricId}/revisionDiff/${request.revisionId}${queryParams}`,
      options
    ).then((response) => response.json())
      .then(GetFabricConfigRevisionDiffResponse.fromJSON);
  },
  queryMetricsHistory: (
    request: HistoryRequest,
    options?: RequestInit | undefined
  ): Promise<HistoryResponse> => {
    return ReST.post(
      `/ui/v1/metrics`,
      generatePayload(request, HistoryRequest),
      options
    ).then((response) => response.json())
      .then(HistoryResponse.fromJSON);
  },
  canvasMcpPost: (
    request: JsonRpcRequest,
    options?: RequestInit | undefined
  ): Promise<JsonRpcResponse> => {
    return ReST.post(
      `/c3/v1/mcp`,
      generatePayload(request, JsonRpcRequest),
      options
    ).then((response) => response.json())
      .then(JsonRpcResponse.fromJSON);
  },
  canvasMcpGet: (
    request: JsonRpcRequest,
    options?: RequestInit | undefined
  ): Promise<JsonRpcResponse> => {
    //Generate query params
    const queryParams = generateQueryParams(
      request
    );
    return ReST.get(
      `/c3/v1/mcp${queryParams}`,
      options
    ).then((response) => response.json())
      .then(JsonRpcResponse.fromJSON);
  },
  discoverTopology: (
    request: DiscoverTopologyRequest,
    options?: RequestInit | undefined
  ): Promise<DiscoverTopologyResponse> => {
    return ReST.post(
      `/api/v1/topologyDiscovery`,
      generatePayload(request, DiscoverTopologyRequest),
      options
    ).then((response) => response.json())
      .then(DiscoverTopologyResponse.fromJSON);
  },
};

